var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrayBackground(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 691,
    viewBox: "0 0 1440 691",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_356_11535)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 691,
    fill: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.17,
    clipPath: "url(#clip1_356_11535)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M625.596 247.187L1657.92 827.511L625.499 1409.43L-406.714 827.511L625.596 247.187Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1328.16 541.152L1657.92 726.525L1328.13 912.408L998.414 726.525L1328.16 541.152Z",
    fill: "#E8E8E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M625.319 -602.27L1657.64 -21.9453L625.222 559.978L-406.992 -21.9453L625.319 -602.27Z",
    fill: "#E8E8E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M625.306 841.738L1657.61 262.998L1657.61 -21.8652L625.306 559.921L625.306 841.738Z",
    fill: "#CBCBCB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M625.347 840.998L-406.957 262.258L-406.957 -20.4014L625.347 559.966L625.347 840.998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.81131 -354.061L395.082 -128.697L-5.84906 97.2881L-406.7 -128.697L-5.81131 -354.061Z",
    fill: "#E8E8E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.81998 206.129L395.066 -18.6198L395.066 -128.391L-5.81988 96.9885L-5.81998 206.129Z",
    fill: "#CBCBCB"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.81996 97.2916L194.623 -15.0829L395.066 -127.457L395.066 -362.854L-5.81991 -137.474L-5.81996 97.2916Z",
    fill: "#CBCBCB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.12 -427.469L1657.89 -135.277L1138.07 157.72L618.357 -135.277L1138.12 -427.469Z",
    fill: "#E8E8E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.12 273.279L1657.63 -17.9674L1657.88 -135.267L1138.12 157.335L1138.12 273.279Z",
    fill: "#CBCBCB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.13 273.278L618.363 -18.1163L618.363 -134.874L1138.13 157.339L1138.13 273.278Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M863.498 3.00651L1108.64 -134.428L1108.64 -189.497L863.498 -51.6775L863.498 3.00651Z",
    fill: "#CBCBCB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M863.502 3.0079L618.359 -134.426L618.359 -189.494L863.502 -51.6737L863.502 3.0079Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M625.313 559.975L714.613 509.911L714.613 118.703L625.313 168.89L625.313 559.975Z",
    fill: "#CBCBCB"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M625.32 559.977L536.02 509.913L536.02 118.698L625.32 168.898L625.32 559.977Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M625.312 68.4082L714.613 118.609L625.303 168.949L536.011 118.609L625.312 68.4082Z",
    fill: "#E8E8E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M625.304 140.507L660.82 120.596L660.82 59.2227L625.304 79.1832L625.304 140.507Z",
    fill: "#CBCBCB"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M625.298 140.506L589.781 120.594L589.781 59.2188L625.298 79.1842L625.298 140.506Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M625.302 39.2168L660.82 59.1836L625.299 79.2054L589.784 59.1836L625.302 39.2168Z",
    fill: "#E8E8E8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_356_11535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 691,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_356_11535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1887,
    height: 748,
    fill: "white",
    transform: "translate(-381)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayBackground);
export default __webpack_public_path__ + "static/media/grayBackground.15a215ba71497caf70da2ec7d723b3be.svg";
export { ForwardRef as ReactComponent };